export default "__VITE_ASSET__51e5ce9c__"